import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";

import { Influencer, InfluencerContact } from "@shared/lib/types/influencer";
import { AgencyService } from "../services/agency.service";
import { BackednResponse } from "@shared/lib/types";
import { AGENCY_LIST_QUERY_KEY } from "../constants/querykeys";
import { Agency } from "@shared/lib/types/agency";

export function useRemoveReview() {
  const {
    mutate: removeReview,
    isLoading: isRemoving,
    isSuccess: isRemoved,
  } = useMutation<
    { agencyId: string; reviewId: string },
    BackednResponse<Agency> | void
  >({
    mutationFn: async ({ agencyId, reviewId }) => {
      return await AgencyService.deleteReview(agencyId, reviewId).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      );
    },
    options: {
      queryKey: AGENCY_LIST_QUERY_KEY,
      skipInvalidation: false,
    },
    onSuccess: (c, data, { agencyId }) => {
      c.invalidateQueries({ queryKey: AGENCY_LIST_QUERY_KEY });
      c.invalidateQueries({
        queryKey: [...AGENCY_LIST_QUERY_KEY, agencyId],
      });
    },
  });

  return {
    removeReview,
    isRemoving,
    isRemoved,
  };
}
